import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import ReactInputMask from "react-input-mask";
import PhoneInput from "react-phone-input-2";
import { json, useLocation, useNavigate } from "react-router-dom";
import { components, default as ReactSelect } from "react-select";
import Switch from "react-switch";
import toast from "react-hot-toast";
import authService from "../../Services/authService";
import clinicService from "../../Services/clinicService";
import utils from "../../Utils";
import strings from "../../Utils/strings";
import validations from "../../Utils/validations";
import "../manageClinic/clinic.css";
import utilFunctions from "../../Utils/utilFunctions";
import { t } from "../../Utils/translate";
import { isValidEmail } from "../manageClinic/helper/validation";
import validator from "validator";
import DoctorTiming from "./doctorTiming";
import Widgets from "../../Widgets";

function AddDoctor({ isClose, onClose, doctorInfo }) {
  // console.log("docdetials" , doctorInfo)
  const nav = useNavigate();
  const state = useLocation();
  const [isDoctorLogin, setIsDoctorLogin] = useState(false);
  const [clinicTimings, setClinicTimings] = useState([]);
  // console.log(clinicTimings)
  const [hospitalDetails, setHospitalDetails] = useState("");
  const [isUpdateProfilePic, setIsUpdateProfilePic] = useState(false);
  const [userProfileImageToShow, setUserProfileImageToShow] = useState(null);
  const [userProfilePic, setUserProfilePic] = useState(null);
  const inputFile = useRef(null);
  const [booking, setBooking] = useState(false);
  const [dayList, setDayList] = useState([]);
  const [timingList, setTimingList] = useState([]);
  const [selectedSpecialtyDepartment, setSelectedSpecialtyDepartment] = useState({});
  const [specialtyDepartment, setSpecialtyDepartment] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState([]);
  const [isToggle, setIsToggle] = useState(false);
  const [doctorname, setDoctorname] = useState(doctorInfo.name);
  const [doctorDescription, setDoctorDescription] = useState(doctorInfo.description);
  const [qualification, setQualification] = useState(doctorInfo.qualification);
  const [slotDuration, setSlotDuration] = useState([]);
  const [selectedSlotDuration, setSelectedSlotDuration] = useState([]);
  const [experienceDate, setExperienceDate] = useState([]);
  const [expInMonth, setExpInMonth] = useState(null);
  const [expInYear, setExpInYear] = useState(null);
  const [error, setError] = useState("");
  const [gender, setGender] = useState(doctorInfo.gender);
  const [defaultCountry, setDefaultCountry] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileErr, setMobileErr] = useState("");
  const [emr, setEmr] = useState(false);
  const [hciCode, setHciCode] = useState("");
  const [doctorEmailId, setDoctorEmailId] = useState(doctorInfo.email);
  const [isDoctorAdded, setIsDoctorAdded] = useState(false);
  const [isClinicAudio, setIsClinicAudio] = useState(false);
  const [isClinicVideo, setIsClinicVideo] = useState(false);
  const [isClinicInHouse, setIsClinicInHouse] = useState(false);
  const [doctorEmailIdErr, setDoctorEmailIdErr] = useState("");
  const [isValid, setIsValid] = useState(false);
  // const listOfYears = utils.constants.listOfYears;
  const [doctorNameErr, setDoctorNameErr] = useState(false);
  const [qualificationErr, setQualificationErr] = useState(false);
  const [mobileNumberErr, setMobileNumberErr] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState(null);
  const [isAddingDoctor, setIsAddingDoctor] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  const [employeeId, setEmployeeId] = useState(doctorInfo.employeeID);
  const [employeeIdErr, setEmployeeIdErr] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [grade] = useState([
    { label: "00", value: "00" },
    { label: "01", value: "01" },
    { label: "02", value: "02" },
    { label: "03", value: "03" },
    { label: "04", value: "04" },
    { label: "05", value: "05" },
    { label: "06", value: "06" },
    { label: "07", value: "07" },
    { label: "08", value: "08" },
    { label: "09", value: "09" },
    { label: "10", value: "10" },
  ]);
  const [selectedGrade, setSelectedGrade] = useState([]);
  const handleGradeChange = (selectedOptions) => {
    setSelectedGrade(selectedOptions || []);
  };

  useEffect(() => {
    setIsDoctorLogin(authService.getIsDoctorLogin() === "true");
  }, []);

  useEffect(() => {
    setSelectedGrade({ label: doctorInfo.grade, value: doctorInfo.grade });
  }, [doctorInfo]);

  useEffect(() => {
    setIsDoctorLogin(authService.getIsDoctorLogin() === "true");
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMobileView(true);
      } else {
        setMobileView(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const minimumGapMinutes = 15;
  const minimumSessionDurationMinutes = 60;
  useEffect(() => {
    setSelectedSlotDuration({
      label: strings.format.labelMin,
      value: strings.format.minValue,
    });
    setExpInMonth(moment(utils.constants.monthCurrentIs, strings.format.MM).format(strings.format.fullMonth));
    getTiming();
    storeInputValues();
    setSlotDuration(utils.constants.getSlotDurationList());
    // let isDoctor = authService.getAddDoctor();
    let isDoctor;
    setIsDoctorAdded(isDoctor);
  }, []);
  const isFetched = useRef(false);
  const [hospitalTime, setHospitalTime] = useState([]);

  const totalYears = Math.floor(doctorInfo.workExperience);
  const decimalPart = doctorInfo.workExperienc - totalYears;

  const months = Math.round(decimalPart * 12);

  const totalMonths = months;

  // console.log(totalYears);
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();

  const experienceYear = currentYear - totalYears;
  const experienceMonth = currentMonth >= totalMonths ? currentMonth - totalMonths : 12 + currentMonth - totalMonths;

  const [selectedYear, setSelectedYear] = useState({ value: experienceYear, label: `${experienceYear}` });
  const [selectedMonth, setSelectedMonth] = useState({ value: experienceMonth, label: moment.months()[experienceMonth] });

  let expInYrs = currentYear - selectedYear.value;

  // console.log(experienceYear)

  const listOfYears = Array.from({ length: 100 }, (_, i) => ({
    value: currentYear - i,
    label: `${currentYear - i}`,
  }));

  const employeeIdHandle = (e) => {
    setEmployeeIdErr("");
    const value = e.target.value.trimStart();
    if (/^\d*$/.test(value)) {
      setEmployeeId(value);
    }
    if (value.length < 3) {
      setEmployeeIdErr(t("minEmployeeIdLenght"));
    }
  };

  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);
  };

  useEffect(() => {
    if (!isFetched.current) {
      getSpecialtyDepartment();
      getLanguages();
      isFetched.current = true;
    }
  }, []);

  const storeInputValues = () => {
    const months = utils.constants.MonthList();
    // setListOfMonths(months);
  };
  useEffect(() => {
    let experienceDate = selectedYear.value + "-" + selectedMonth.value + "-" + utils.constants.currentDate;
    setExperienceDate(experienceDate);
    workExperience(experienceDate);
  }, [selectedYear, selectedMonth]);

  useEffect(() => {
    validateMobileNumber();
  }, [mobileNumber]);

  const handleClinicTimingsChange = (updatedTimings) => {
    // console.log("clinin timing changes")
    setClinicTimings(updatedTimings);
  };

  useEffect(() => {
    setUserProfileImageToShow(doctorInfo?.profilePic);
    let doctorDepartmentArr = {
      label: doctorInfo.departmentList[0].departmentName,
      value: doctorInfo.departmentList[0]._id,
    };
    let setLanguages = doctorInfo.languages.map((data) => ({
      label: data,
      value: data,
    }));
    setSelectedLanguage(setLanguages);
    setMobileNumber(doctorInfo.phoneNumber);
    setSelectedSpecialtyDepartment(doctorDepartmentArr);
  }, [doctorInfo]);

  // console.log(doctorInfo);

  const getTiming = async () => {
    let response;
    if (response) {
      if (response.clinicTimings && response.clinicTimings.length > 0) {
        let resArr = response.clinicTimings;
        let arr = utils.constants.dayList;
        resArr.map((resItem, resIndx) => {
          arr.map((item, i) => {
            if (item.day === resItem.day) {
              let timeArr = [];
              let timingArr = [];
              resItem.timings.map((timeItem, timeIndx) => {
                timingArr.push({
                  _id: resItem._id,
                  day: resItem.day,
                  status: true,
                });
                let startHr = timeItem.startHour.toString();
                let startMin = timeItem.startMinute.toString();
                let endHr = timeItem.endHour.toString();
                let endMin = timeItem.endMinute.toString();
                startHr = startHr && startHr.length === 1 ? "0" + startHr : startHr;
                startMin = startMin && startMin.length === 1 ? "0" + startMin : startMin;
                endHr = endHr && endHr.length === 1 ? "0" + endHr : endHr;
                endMin = endMin && endMin.length === 1 ? "0" + endMin : endMin;
                let timeObj = {
                  from: startHr + ":" + startMin,
                  to: endHr + ":" + endMin,
                  status: true,
                };
                timeArr.push(timeObj);
              });
              let dd = [...item.timing];
              dd = timeArr;
              if (timeArr.length > 0) {
                item.status = true;
                item.isActive = true;
              }
              item.timing = timeArr;
              setIsToggle(true);
            }
          });
        });
        setDayList(arr);
      } else {
        setDayList(utils.constants.dayList);
      }
    } else {
      setDayList(utils.constants.dayList);
    }
  };
  const Option = (props) => {
    const { label, isSelected } = props;
    return (
      <div className="d-flex justify-content-center">
        <components.Option {...props}>
          <div className="d-flex">
            <div className="form-check">
              <input
                style={{
                  accentColor: utils.appStyles.color.primaryColor,
                  marginRight: "5px",
                }}
                type="checkbox"
                value={props.label}
                id="flexCheckDefault"
                checked={props.isSelected}
                onChange={() => null}
              />
              <label
                style={{
                  fontFamily: "Arial, sans-serif",
                  fontSize: "14px",
                  color: "#333",
                }}
                for="flexCheckDefault"
              >
                {props.label}
              </label>
            </div>
          </div>
        </components.Option>
      </div>
    );
  };

  const handleChange = (selectedOptions) => {
    setSelectedSpecialtyDepartment(selectedOptions);
    if (state.pathname !== strings.navigation.manageDoctor) {
      authService.localStorageInputValues.setDoctorSpecialty(JSON.stringify(selectedOptions));
    }
    setIsFocused(false);
  };
  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleChangeLanguage = (selectedLanguage) => {
    setSelectedLanguage(selectedLanguage);
    if (state.pathname !== strings.navigation.manageDoctor) {
      authService.localStorageInputValues.setDoctorLanguage(JSON.stringify(selectedLanguage));
    }
  };

  const getSpecialtyDepartment = async () => {
    try {
      let response;
      let doctorDepartmentArr;
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.docGetClinicProfile();
        let departments = response.data.hospital.departmentList;
        doctorDepartmentArr = departments.map((data) => ({
          label: data.departmentName,
          value: data._id,
        }));

        // console.log(doctorDepartmentArr)

        setSpecialtyDepartment(doctorDepartmentArr);
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.getDoctorSpecialtyDepart();
        if (response && response.data && response.data.departments) {
          let departments = response.data.departments;
          doctorDepartmentArr = departments.map((data) => ({
            label: data.departmentName,
            value: data._id,
          }));

          setSpecialtyDepartment(doctorDepartmentArr);
        }
      }
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const getLanguages = async () => {
    try {
      let response;
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.docGetLanguages();
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.getLanguages();
      }
      if (response) {
        if (response.data.languages && response.data.languages.length > 0) {
          let languageList = response.data.languages;

          let langArr = [];
          languageList.map((data) => {
            let obj = {
              label: data.name,
              value: data.name,
            };
            langArr.push(obj);
          });

          setLanguages(langArr);
        } else {
          setLanguages([]);
        }
      } else {
        setLanguages([]);
      }
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  async function workExperience(expDate) {
    if (expDate != null || expDate != "") {
      let expMonth;
      const selectedDate = moment(expDate, strings.format.date);
      const currentDate = moment();
      if (currentDate.diff(selectedDate, strings.addDoctor.label_months) !== NaN || currentDate.diff(selectedDate, strings.addDoctor.label_years) !== NaN) {
        if (currentDate.diff(selectedDate, strings.addDoctor.label_months) >= 12) {
          expMonth = currentDate.diff(selectedDate, strings.addDoctor.label_months) % 12;
        } else {
          expMonth = currentDate.diff(selectedDate, strings.addDoctor.label_months);
        }
        let expYear = currentDate.diff(selectedDate, strings.addDoctor.label_years);
        setExpInMonth(expMonth);
        setExpInYear(expYear);
      }
    }
  }
  const handleGenderChange = (event) => {
    setGender(event.target.value);
    if (state.pathname !== strings.navigation.manageDoctor) {
      authService.localStorageInputValues.setDoctorGender(event.target.value);
    }
  };

  const handleMobleNumberHandler = (e) => {
    let item = e.target.value;
    item = item.replace(/\s+/g, "");
    let errorMsg = validations.phoneValidator1(item, defaultCountry);
    if (item == "") {
      setMobileNumber(item);
      setMobileErr(utils.strings.validations.mobileNumber);
      if (state.pathname !== strings.navigation.manageDoctor) {
        authService.localStorageInputValues.setDoctorMobileNumber(item);
      }
    } else {
      if (errorMsg !== "") {
        setMobileErr(errorMsg.message);
      } else {
        setMobileNumber(item);
        if (state.pathname !== strings.navigation.manageDoctor) {
          authService.localStorageInputValues.setDoctorMobileNumber(item);
        }
      }
    }
    let errorMsgs = utilFunctions.checkIsMobileNumberValid(defaultCountry, item);
    setMobileNumberErr(errorMsgs);
    validateMobileNumber();
  };

  const handlerDoctorEmailChanges = (e) => {
    let item = e.target.value.trim();
    let errorMsg = validations.emailValidator(item);
    if (validator.isEmail(item)) {
      setDoctorEmailId(e.target.value.trim());
      if (state.pathname !== strings.navigation.manageDoctor) {
        authService.localStorageInputValues.setDoctorEmailId(e.target.value);
      }
    } else {
      setDoctorEmailId(e.target.value.trim());
      if (state.pathname !== strings.navigation.manageDoctor) {
        authService.localStorageInputValues.setDoctorEmailId(e.target.value);
      }
    }
    if (errorMsg !== "") {
      setDoctorEmailIdErr(errorMsg);
    } else {
      setDoctorEmailIdErr("");
    }
    setDoctorEmailId(e.target.value.trim());
    if (state.pathname !== strings.navigation.manageDoctor) {
      authService.localStorageInputValues.setDoctorEmailId(e.target.value);
    }
  };

  const doctorTimingEnable = () => {
    let arr = dayList;
    let isValid = true;
    arr.forEach((ele, ind) => {
      if (ele.status === false) {
        isValid = false;
      }
    });
    return isValid;
  };

  const disableButton = () => {
    // console.log(clinicTimings)
    let returnValue = false;
    if (
      doctorname !== " " &&
      doctorname &&
      employeeId &&
      employeeId.length > 2 &&
      doctorname.length > 0 &&
      qualification !== "" &&
      qualification &&
      qualification.length > 0 &&
      mobileNumber !== "" &&
      mobileNumber &&
      mobileNumber.length > 0 &&
      specialtyDepartment &&
      selectedLanguage &&
      selectedLanguage.length > 0 &&
      gender &&
      gender.length > 0 &&
      doctorEmailId &&
      doctorEmailId.length > 0 &&
      isValid &&
      !isAddingDoctor
    ) {
      if (!isValidEmail(doctorEmailId)) {
        returnValue = true;
      }
    } else {
      returnValue = true;
    }

    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

    let isTimeValid = true;

    for (const day of clinicTimings) {
      if (!day.status) continue;

      for (const slot of day.timing) {
        if (!timeRegex.test(slot.from) || !timeRegex.test(slot.to) || slot.from >= slot.to) {
          isTimeValid = false;
          break;
        }
      }

      if (!isTimeValid) break;
    }
    if (!isTimeValid) {
      returnValue = true;
    }

    // console.log("return value", returnValue)
    return returnValue;
  };

  const timeToNumber = (timeStr) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours * 60 + minutes;
  };

  const validateDoctorTimings = (openingHoursSpecification) => {
    for (const doctorTime of openingHoursSpecification) {
      const hospitalDay = hospitalTime.find((h) => h.dayOfWeek === doctorTime.dayOfWeek);

      if (!hospitalDay) {
        toast.error(`Hospital timing not found for ${doctorTime.dayOfWeek}`);
        continue;
      }

      const hospitalOpens = timeToNumber(hospitalDay.opens);
      const hospitalCloses = timeToNumber(hospitalDay.closes);

      for (const session of doctorTime.sessions) {
        const sessionOpens = timeToNumber(session.opens);
        const sessionCloses = timeToNumber(session.closes);

        if (sessionOpens < hospitalOpens || sessionCloses > hospitalCloses) {
          toast.error(
            t("sessionOutsideTiming", {
              doctorTime: { dayOfWeek: doctorTime.dayOfWeek },
              opens: session.opens,
              closes: session.closes,
            }),
          );
          return false;
        }
      }
    }
    return true;
  };

  const docId = doctorInfo._id;

  const addDoctor = async () => {
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

    let isTimeValid = true;

    for (const day of clinicTimings) {
      if (!day.status) continue;

      for (const slot of day.timing) {
        if (!timeRegex.test(slot.from) || !timeRegex.test(slot.to) || slot.from >= slot.to) {
          isTimeValid = false;
          toast.error(t("invalidTimeOrSlot"));
          break;
        }
      }

      if (!isTimeValid) break;
    }
    if (!isTimeValid) {
      return;
    }
    try {
      setIsLoading(true);
      if (!isAddingDoctor) {
        setIsAddingDoctor(true);
        let selectedLang = selectedLanguage.map((lang) => lang.label);
        let doctorTimeList = utils.utilFunctions.getTime(dayList);

        const formatOpeningHours = () => {
          const daysMap = {
            MONDAY: "Monday",
            TUESDAY: "Tuesday",
            WEDNESDAY: "Wednesday",
            THURSDAY: "Thursday",
            FRIDAY: "Friday",
            SATURDAY: "Saturday",
            SUNDAY: "Sunday",
          };

          return clinicTimings.map((day) => {
            const sessions = [{ opens: day.timing[0]?.from, closes: day.timing[0]?.to }];
            return {
              dayOfWeek: day.displayDay,
              sessions: day.status ? sessions : [],
            };
          });
        };

        function combineExperience(expInYear, expInMonth) {
          const totalExperienceInYears = expInYear + expInMonth / 12;
          return totalExperienceInYears;
        }
        const combinedExperience = combineExperience(expInYear, expInMonth);

        const openingHoursSpecification = formatOpeningHours();

        // const isValid = validateDoctorTimings(openingHoursSpecification);
        // if (!isValid) {
        //   console.log("Please ensure doctor timings are within hospital timings.");
        //   return;
        // }
        // console.log(selectedSpecialtyDepartment.value);
        let doctorInfo = {
          name: doctorname,
          description: doctorDescription,
          gender: gender,
          workExperience: expInYrs,
          languages: selectedLang,
          openingHours: ["Mo-Su 00:00-23:59"],
          openingHoursSpecification: openingHoursSpecification,
          departmentList: [selectedSpecialtyDepartment.value],
          profilePic: userProfileImageToShow?.replace(/ /g, "%20"),
          qualification: qualification,
          grade: selectedGrade.value,
          employeeID: employeeId,
        };
        // console.log(openingHoursSpecification)

        let response;
        if (authService.getIsDoctorLogin() === "true") {
          response = await clinicService.docEditDoctor(doctorInfo);
        } else if (authService.getIsDoctorLogin() === "false") {
          response = await clinicService.editDoctor(docId, doctorInfo);
        }
        // let response;
        if (response) {
          if (response.status === "success") {
            toast.success(t("doctorUpdatedSuccess"));
            if (mobileView) {
              window.location.reload();
            } else {
              onClose(false);
            }
          } else {
            toast.dismiss();
            toast.error(response.data.message);
          }
        } else {
          toast.error("No response from server");
        }

        setIsAddingDoctor(false);
      }
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
      setIsAddingDoctor(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    try {
      setIsLoading(true);
      let response;
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.uploadDoctorMedia(files[0]);
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.uploadHospitalMedia(files[0]);
      }
      setIsLoading(false);
      if (response.status === "success") {
        const docImgUrl = response.data.urls[0];
        setIsUpdateProfilePic(true);
        setUserProfileImageToShow(docImgUrl);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("File upload failed:", error);
    }
  };

  function onCollisionCheck(inputType, value, item, timeArrIndex, dayArrIndex) {
    let dayListArr = [...dayList];
    let arr = [...item.timing];
    let res = utils.utilFunctions.checkTimeCollision(arr, timeArrIndex);
    if (!res) {
      toast.dismiss();
      toast.error(t("invalidTimeOrSlot"));
      if (inputType == strings.addDoctor.label_from) {
        arr[timeArrIndex] = {
          from: "__:__",
          to: arr[timeArrIndex].to,
        };
      } else if (inputType == strings.addDoctor.label_to) {
        arr[timeArrIndex] = {
          from: arr[timeArrIndex].from,
          to: "__:__",
        };
      }
      dayListArr[dayArrIndex].timing = arr;
      setDayList(dayListArr);
    }
  }

  const validateMobileNumber = () => {
    if (defaultCountry == utils.constants.country.singapore && mobileNumber.length == 8) {
      setIsValid(true);
    } else if (defaultCountry == utils.constants.country.india && mobileNumber.length == 10) {
      setIsValid(true);
    } else if (defaultCountry != utils.constants.country.singapore && defaultCountry != utils.constants.country.india && mobileNumber.length >= 8) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  function doctorHandler(e) {
    let item = e.target.value.trimStart();
    let errorMsg = validations.doctorNameValidator(item);
    if (errorMsg.add) {
      setDoctorname(item);
      if (state.pathname !== strings.navigation.manageDoctor) {
        authService.localStorageInputValues.setDoctorName(item);
      }
    }
    if (errorMsg.message !== "") {
      setDoctorNameErr(errorMsg.message);
    } else {
      setDoctorNameErr("");
    }
  }

  function qualificationHandler(e) {
    let item = e.target.value.trimStart();
    let errorMsg = validations.qualificationValidator(item);
    if (errorMsg.add) {
      setQualification(item);
    } else {
      if (errorMsg.message != "") {
        setQualificationErr(errorMsg.message);
      } else {
        setQualificationErr("");
      }
    }
    setQualification(item);
    if (state.pathname !== strings.navigation.manageDoctor) {
      authService.localStorageInputValues.setQualification(item);
    }
  }

  function setInputValue(inputType, value, item, timeArrIndex, dayArrIndex) {
    let dayListArr = [...dayList];
    let arr = [...item.timing];
    if (inputType == strings.addDoctor.label_from) {
      arr[timeArrIndex] = {
        from: value,
        to: arr[timeArrIndex].to,
      };
    } else if (inputType === strings.addDoctor.label_to) {
      arr[timeArrIndex] = {
        from: arr[timeArrIndex].from,
        to: value,
      };
    }
    dayListArr[dayArrIndex].timing = arr;
    setDayList(dayListArr);
  }

  return (
    <>
      {isLoading ? <Widgets.CircularLoader /> : ""}
      <div className="mt-3" style={{ maxHeight: "80vh", overflowY: "auto" }}>
        <div className="profile-photo">
          <div
            onClick={() => {
              inputFile.current.click();
            }}
            className="profile-icon"
          >
            {userProfileImageToShow ? <img src={userProfileImageToShow} className="profile-picture" /> : <i className="ri-nurse-line profile-icon-logo"> </i>}

            <div style={{ visibility: "none" }}>
              <input style={{ display: "none" }} type="file" accept="image/*" onChange={handleImageUpload} ref={inputFile} />
            </div>
          </div>
        </div>

        <i
          className="ri-camera-2-line camera-icon"
          onClick={() => {
            inputFile.current.click();
          }}
        ></i>

        <span className="profile-photo-span mt-2 mb-3">{t("doctorProfilePhoto")}</span>

        <span className="configuration-labels">{t("doctorDetails")}</span>

        <div className="profile-form mt-2">
          <div className="mb-1">
            <div className="input-group input-group-lg">
              <input
                type="text"
                className="form-control text-control"
                placeholder={t("doctornamePlaceholder")}
                aria-label="Default"
                aria-describedby="inputGroup-sizing-sm"
                maxLength={100}
                value={doctorname}
                onChange={doctorHandler}
              />
            </div>
            <div className="mt-1">
              <span className="d-flex error-container">
                {doctorNameErr.length > 0 ? <i className="ri-information-line me-1" /> : null}
                {doctorNameErr}
              </span>
            </div>
          </div>
          <div className="mb-1">
            <div className="input-group input-group-lg">
              <input
                type="text"
                className="form-control text-control"
                placeholder={t("employeeId")}
                aria-label="Default"
                aria-describedby="inputGroup-sizing-sm"
                maxLength={4}
                value={employeeId}
                onChange={employeeIdHandle}
                disabled={true}
              />
            </div>
            <div className="mt-1">
              <span className="d-flex error-container">
                {employeeIdErr.length > 0 ? <i className="ri-information-line me-1" /> : null}
                {employeeIdErr}
              </span>
            </div>
          </div>
          <div className="mb-1">
            <div className="input-group input-group-lg">
              <input
                type="text"
                className="form-control text-control"
                placeholder={t("qualificationPlaceholder")}
                aria-describedby="inputGroup-sizing-sm"
                maxLength={50}
                value={qualification}
                onChange={qualificationHandler}
              />
            </div>
            <div className="mt-1">
              <span className="d-flex error-container">
                {qualificationErr.length > 0 ? <i className="ri-information-line me-1" /> : null}
                {qualificationErr}
              </span>
            </div>
          </div>
          <div className="mb-4">
            <div className="input-group input-group-lg">
              <input
                type="text"
                className="form-control text-control"
                placeholder={t("descriptionPlaceholder")}
                aria-describedby="inputGroup-sizing-sm"
                value={doctorDescription}
                maxLength={500}
                onChange={(e) => {
                  setDoctorDescription(e.target.value.trimStart());
                  if (state.pathname !== strings.navigation.manageDoctor) {
                    authService.localStorageInputValues.setDoctorDescription(e.target.value);
                  }
                }}
              />
            </div>
          </div>
          <div className="mb-1">
            <div className="input-group input-group-lg">
              <input
                type="text"
                className="form-control  text-control"
                placeholder={t("emailIdPlaceholder")}
                aria-label="Default"
                aria-describedby="inputGroup-sizing-sm"
                maxLength={50}
                value={doctorEmailId}
                disabled={true}
                onChange={handlerDoctorEmailChanges}
              />
            </div>
            <div className="mt-1">
              <span className="d-flex error-container">
                {doctorEmailIdErr && doctorEmailIdErr.length > 0 ? <i className="ri-information-line me-1" /> : null}
                {doctorEmailIdErr}
              </span>
            </div>
          </div>

          <div className="mb-4">
            <ReactSelect
              styles={utils.appStyles.selectDropDownPrimaryNoBackground}
              placeholder={t("specialtyPlaceholder")}
              options={specialtyDepartment}
              components={{ Option }}
              onChange={handleChange}
              value={isFocused ? null : selectedSpecialtyDepartment}
              onFocus={handleFocus}
              onBlur={handleBlur}
              hideSelectedOptions={false}
              closeMenuOnSelect={true}
            />
            <div className="mt-1">{selectedSpecialtyDepartment.length == 0 ? <span className="d-flex error-container">{t("specialityEmpty")}</span> : ""}</div>
          </div>
          <div className="mb-4">
            <ReactSelect
              styles={utils.appStyles.selectDropDownPrimaryNoBackground}
              placeholder={t("selectGrade")}
              options={grade}
              hideSelectedOptions={false}
              onChange={handleGradeChange}
              components={{ Option }}
              value={selectedGrade}
              closeMenuOnSelect={true}
            />
          </div>
          <div className="clinic-timing-boxes d-flex justify-content-between mb-3">
            <span className="weekNames">{t("labelGender")}</span>
            <div>
              <input name="fav_language" type="radio" value={strings.addDoctor.labelMale} defaultChecked={gender === strings.addDoctor.labelMale} onChange={handleGenderChange} />
              <label className="mx-2 gender-label-resp">{t("labelMale")}</label>
              <input name="fav_language" type="radio" value={strings.addDoctor.labelFemale} defaultChecked={gender === strings.addDoctor.labelFemale} onChange={handleGenderChange} />
              <label className="mx-2 gender-label-resp-f">{t("labelFemale")}</label>
            </div>
          </div>

          <div className="mb-2 phone-input-field">
            <div className="form-group input-group-lg row responsive-form ">
              <div className="code-container mb-3">
                <PhoneInput value={doctorInfo.countryCode} enableSearch={false} disableDropdown={true} countryCodeEditable={false} style={{ height: "53px" }} />
              </div>
              <div className="number-container">
                <input
                  style={{ height: "53px" }}
                  type="text"
                  placeholder={t("mobileNumberPlaceholder")}
                  className="form-control text-control"
                  value={mobileNumber}
                  disabled={true}
                  onChange={(e) => {
                    let val = e.target.value;
                    if (val && val.length > 0) {
                      if (val[0] == 0) {
                        val = val.substring(1);
                        setMobileNumber(val);
                      } else {
                        handleMobleNumberHandler(e);
                      }
                    } else {
                      handleMobleNumberHandler(e);
                    }
                  }}
                />
                <>
                  {mobileErr && mobileErr.length > 0 ? (
                    <span className="d-flex error-container space">
                      <i className="ri-information-line me-1" />
                      {mobileErr}
                    </span>
                  ) : (
                    <>
                      {mobileNumberErr && mobileNumberErr.length > 0 && (
                        <span className="d-flex error-container space">
                          <i className="ri-information-line me-1" />
                          {mobileNumberErr}
                        </span>
                      )}
                    </>
                  )}
                </>
              </div>
            </div>
          </div>
          <div className="mb-2">
            <span className="configuration-labels">{t("workExperience")}</span>
          </div>

          <div>
            <span>{t("btnFrom")}</span>
            <div className="row vital-input-field">
              <div className="row">
                <div className="col-12 my-2">
                  <ReactSelect styles={utils.appStyles.selectDropDownPrimary} placeholder="Select Years" options={listOfYears} value={selectedYear} onChange={handleYearChange} />
                </div>
                {/* <div className="col-6 my-2">
                  <ReactSelect
                    styles={utils.appStyles.selectDropDownPrimary}
                    placeholder="Select Months"
                    options={listOfMonths}
                    value={selectedMonth}
                    onChange={handleMonthChange}
                  />
                </div> */}
              </div>
              <div>
                <span className="me-1">{expInYrs + t("WorkExperienceInYear")}</span>
                {/* <span>
                  {isNaN(expInMonth)
                    ? ""
                    : expInMonth > 1
                    ? +expInMonth + strings.addDoctor.labelMonths
                    : expInMonth !== 0
                    ? expInMonth + t("labelMonth")
                    : ""}
                </span> */}
              </div>
            </div>
          </div>
          <div className="mb-3">
            <span className="configuration-labels">{t("labelLanguage")}</span>

            <div className="mt-2">
              <ReactSelect
                styles={utils.appStyles.selectDropDownPrimaryNoBackground}
                placeholder={t("languagePlaceholder")}
                options={languages}
                isMulti
                hideSelectedOptions={false}
                components={{ Option }}
                onChange={handleChangeLanguage}
                allowSelectAll={true}
                value={selectedLanguage}
                closeMenuOnSelect={false}
              />
            </div>

            <div className="my-3">{selectedLanguage.length == 0 ? <span className="d-flex error-container">{t("languageEmpty")}</span> : ""}</div>
          </div>
          <div className="clinic-timing-item-container mt-1">
            <DoctorTiming doctorTiming={doctorInfo.openingHoursSpecification} onClinicTimingsChange={handleClinicTimingsChange} hospitalTime={hospitalTime} setHospitalTime={setHospitalTime} />

            {isDoctorAdded === "true" ? (
              <div className="col-12 d-flex mt-4">
                <button
                  className="dialog-btn dialog-btn-type-bordered me-2"
                  onClick={() => {
                    onClose(false);
                  }}
                >
                  {t("btnCancel")}
                </button>
                <button
                  type="button"
                  style={{ backgroundColor: "#DF5551", width: "150px" }}
                  className="btn dialog-btn dialog-btn-type-filled"
                  disabled={disableButton()}
                  onClick={() => {
                    // manageAddDoctor();
                  }}
                >
                  {t("done")}
                </button>
              </div>
            ) : (
              <div className="col-12 d-flex mt-4 mb-2">
                <button
                  style={{ width: "150px" }}
                  className="dialog-btn dialog-btn-type-bordered me-2"
                  onClick={() => {
                    onClose(false);
                  }}
                >
                  {t("btnCancel")}
                </button>
                <button
                  type="button"
                  style={{ backgroundColor: "#DF5551", width: "150px" }}
                  className="btn dialog-btn dialog-btn-type-filled"
                  onClick={() => {
                    addDoctor();
                  }}
                  disabled={disableButton()}
                >
                  {t("btnSubmit")}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AddDoctor;
